<template>
  <div v-if="IsLogin" class="home inline-block w-full">
    <StudentInfo @on-change="changeIsLogin"></StudentInfo>
  </div>
  <div v-else-if="isGuestAccessibleRoute" class="inline-block w-full">
    <router-view></router-view>
  </div>
  <div v-else class="inline-block w-full">
    <LoginPanel></LoginPanel>
  </div>
</template>

<script>
import StudentInfo from "../components/StudentInfo.vue";
import LoginPanel from "../components/LoginPanel.vue";
import store from "@/store/index.js";
import { onMounted, ref, computed } from "@vue/runtime-core";
import { useCookies } from "vue3-cookies";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";

export default {
  name: "Home",
  components: {
    StudentInfo,
    LoginPanel,
  },
  setup() {
    const userId = ref("");
    const router = useRouter();
    const route = useRoute();

    const IsLogin = computed(() => {
      return store.state.IsLogin;
    });
    const isGuestAccessibleRoute = computed(
      () => route.path === "/feedback/course"
    );

    const { cookies } = useCookies();

    onMounted(async () => {
      const postLoginRedirect = sessionStorage.getItem("postLoginRedirect");
      const maybeRedirectAfterLogin = async () => {
        if (!postLoginRedirect) return;
        sessionStorage.removeItem("postLoginRedirect");
        await router.replace(postLoginRedirect);
      };

      var cookieToken = cookies.get("isLogin");
      if (window.location.href.includes("localhost")) {
        store.commit("Login");
        IsLogin.value = true;
        await maybeRedirectAfterLogin();
      } else if (cookieToken) {
        if (!localStorage.getItem("jwt-token")) {
          await axios
            .get(process.env.VUE_APP_api_url + "/login/register", {
              stuId: cookies.get("userId"),
            })
            .then((response) => {
              localStorage.setItem("jwt-token", response.data.token);
            });
        }
        store.commit("Login");
        await maybeRedirectAfterLogin();
      } else {
        // If user was redirected here from a protected action,
        // keep the redirect target across the "not logged in yet" state.
        store.commit("Logout");
        if (postLoginRedirect) {
          sessionStorage.setItem("postLoginRedirect", postLoginRedirect);
        }
      }
    });

    return { userId, IsLogin, isGuestAccessibleRoute };
  },
};
</script>
